import {getNorthCitiesIds} from "@models/area";
import {getCityById} from "@models/district";
import {isEmpty, str_replace} from "@helpers/helpers";
import {inArray} from "@helpers/arrays";
import {getWidgets} from "@models/widget";
import {getRedisCache, storeRedisCache} from "../../../helpers/redis_cache";

export const handleBrandUrl = (defaultCity) => {
    let url = '/';

    if (!isEmpty(defaultCity)) {
        url += 'املاک-' + str_replace(' ', '-', defaultCity.name);
    }

    if (!isEmpty(defaultCity) && defaultCity.id === 3198) {
        url = '/املاک-شمال/خرید-فروش-ویلا';
    } else if (!isEmpty(defaultCity) && defaultCity.id === 3614) {
        url = '/املاک-چمستان/خرید-فروش-ویلا';
    }

    return url;
};

async function getNavSaleLinks(defaultCityId) {
    const params = {
        type: 'static_links',
        page: 'home',
        section: 'nav_sale',
        city_id: defaultCityId,
        count: 10
    };

    const result = await getWidgets(params);

    return (!isEmpty(result) && result.widgets) ? result.widgets : [];
}

async function getNavRentLinks(defaultCityId) {
    const params = {
        type: 'static_links',
        page: 'home',
        section: 'nav_rent',
        city_id: defaultCityId,
        count: 10
    };

    const result = await getWidgets(params);

    return (!isEmpty(result) && result.widgets) ? result.widgets : [];
}

async function makeNavbarLinks(defaultCityId) {
    const northCitiesIds = await getNorthCitiesIds();
    const defaultCity = await getCityById(defaultCityId);

    const isNorthCity = !isEmpty(defaultCity) ? (inArray(defaultCity.id, northCitiesIds)) : false;
    const saleLink = !isEmpty(defaultCity) ? (isNorthCity ? '/املاک-شمال/خرید-فروش-ویلا' : '/املاک-' + str_replace(' ', '-', defaultCity.name) + '/خرید-فروش-آپارتمان') : '#';
    const rentLink = !isEmpty(defaultCity) ? '/املاک-' + str_replace(' ', '-', defaultCity.name) + '/رهن-اجاره-آپارتمان' : '#';

    const navSaleLinks = !isEmpty(defaultCityId) ? await getNavSaleLinks(defaultCityId) : [];
    const navRentLinks = !isEmpty(defaultCityId) ? await getNavRentLinks(defaultCityId) : [];

    return {
        city_id: defaultCityId,
        isNorthCity: isNorthCity,
        navSaleLinks: navSaleLinks,
        navRentLinks: navRentLinks,
        defaultCity: defaultCity,
        saleLink: saleLink,
        rentLink: rentLink,
    }
}

export async function handleNavbarLinks(defaultCityId) {
    const cacheKey = 'navbarLinks:city-' + defaultCityId;
    const cacheTTL = 24 * 60 * 60;
    let data;

    if (!process.browser) {
        data = await getRedisCache(cacheKey);

        if (isEmpty(data)) {
            data = await makeNavbarLinks(defaultCityId);

            await storeRedisCache(cacheKey, data, cacheTTL);
        }
    } else {
        data = await makeNavbarLinks(defaultCityId);
    }

    return data;
}